import * as React from 'react';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { UnitsPage } from '@/pages/v2/units';
import { UnitPage } from '@/pages/v2/units/unit';
import { RoleGuard } from '@/components/auth/guards/role-guard';

import { COMMUNITY_ROLES } from '@/constants/community-roles';
import { ACCOUNT_ROLES } from '@/constants/account-roles';

export const route: RouteObject = {
  path: paths.units.index,
  element: (
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          displayUnauthorized
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER]}
        >
          <UnitsPage />
        </RoleGuard>
      ),
    },
    {
      path: paths.units.details(':unitId'),
      element: (
        <RoleGuard
          displayUnauthorized
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
            ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER]}
        >
          <UnitPage />
        </RoleGuard>
      ),
    },
  ],
};
